var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 21.3958C16.9653 21.3958 21.3958 16.9653 21.3958 11.5C21.3958 6.03469 16.9653 1.60417 11.5 1.60417C6.03469 1.60417 1.60417 6.03469 1.60417 11.5C1.60417 16.9653 6.03469 21.3958 11.5 21.3958ZM11.5 22.4375C17.5406 22.4375 22.4375 17.5406 22.4375 11.5C22.4375 5.45938 17.5406 0.5625 11.5 0.5625C5.45938 0.5625 0.5625 5.45938 0.5625 11.5C0.5625 17.5406 5.45938 22.4375 11.5 22.4375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 15.3333C13.5135 15.3333 15.1458 13.701 15.1458 11.6875C15.1458 9.67396 13.5135 8.04167 11.5 8.04167C9.48646 8.04167 7.85417 9.67396 7.85417 11.6875C7.85417 13.701 9.48646 15.3333 11.5 15.3333ZM11.5 16.375C14.0889 16.375 16.1875 14.2764 16.1875 11.6875C16.1875 9.09865 14.0889 7 11.5 7C8.91115 7 6.8125 9.09865 6.8125 11.6875C6.8125 14.2764 8.91115 16.375 11.5 16.375Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.896 5.77081C8.896 6.63378 8.19646 7.33331 7.3335 7.33331C6.47053 7.33331 5.771 6.63378 5.771 5.77081C5.771 4.90784 6.47053 4.20831 7.3335 4.20831C8.19646 4.20831 8.896 4.90784 8.896 5.77081Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.021 12.0208C12.021 12.8838 11.3215 13.5833 10.4585 13.5833C9.59553 13.5833 8.896 12.8838 8.896 12.0208C8.896 11.1578 9.59553 10.4583 10.4585 10.4583C11.3215 10.4583 12.021 11.1578 12.021 12.0208Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7915 15.6667C18.7915 16.5297 18.092 17.2292 17.229 17.2292C16.366 17.2292 15.6665 16.5297 15.6665 15.6667C15.6665 14.8037 16.366 14.1042 17.229 14.1042C18.092 14.1042 18.7915 14.8037 18.7915 15.6667Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.146 5.77083C15.4337 5.77083 15.6668 5.53766 15.6668 5.25C15.6668 4.96234 15.4337 4.72917 15.146 4.72917C14.8583 4.72917 14.6252 4.96234 14.6252 5.25C14.6252 5.53766 14.8583 5.77083 15.146 5.77083ZM15.146 6.8125C16.009 6.8125 16.7085 6.11297 16.7085 5.25C16.7085 4.38703 16.009 3.6875 15.146 3.6875C14.283 3.6875 13.5835 4.38703 13.5835 5.25C13.5835 6.11297 14.283 6.8125 15.146 6.8125Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.771 16.1875C6.05865 16.1875 6.29183 15.9543 6.29183 15.6667C6.29183 15.379 6.05865 15.1459 5.771 15.1459C5.48334 15.1459 5.25016 15.379 5.25016 15.6667C5.25016 15.9543 5.48334 16.1875 5.771 16.1875ZM5.771 17.2292C6.63396 17.2292 7.3335 16.5297 7.3335 15.6667C7.3335 14.8037 6.63396 14.1042 5.771 14.1042C4.90803 14.1042 4.2085 14.8037 4.2085 15.6667C4.2085 16.5297 4.90803 17.2292 5.771 17.2292Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImm);
export default __webpack_public_path__ + "static/media/Imm.778a3ec0fd0eacc7be1b200e7f504067.svg";
export { ForwardRef as ReactComponent };